import { apiSlice } from "./ApiSlice";

const MakeAppointmentApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    Makeappointment: builder.mutation({
      query: (credentials) => {
       
        return {
          url: "/api/ClinicProfile/MakeAppointment",
          method: "POST",
          body: JSON.stringify(credentials),
          headers: {
            "Content-Type": "application/json",
          },
        };
      },
      invalidatesTags: ["Appointments"],
    }),

    NotAttendedAppointment: builder.mutation({
      query: ({ appointmentId }) => {

        const formData = new FormData();
        formData.append("appointmentID", appointmentId);

        return {
          url: `/api/ClinicProfile/Patient-Not-attenteded-Appointment`,
          method: "POST",
          body: formData,
          
        };
      },
      invalidatesTags: ["Appointments"],
    }),


    populateSelectAppointmentModal: builder.query({
      query: ({
        searchindex,
        userClinicID,
        specialization,
        doctorID,
        patient,
        weekday,
      }) => {
        return {
          url: `/api/ClinicProfile/GetAppointmentDropdowns?searchindex=${searchindex}&userClinicID=${userClinicID}&doctorID=${doctorID}&weekday=${weekday}&specialization=${specialization}&patient=${patient}`,
          method: "GET",
        };
      },
    }),

    RescheduleAppointment: builder.mutation({
      query: (rescheduleData) => ({
        url: "/api/DoctorProfile/Appointment-Reschedule",
        method: "POST",
        body: rescheduleData,
      }),
      invalidatesTags: ["Appointments"],
    }),
    getDoctorsSchedule: builder.query({
      query: ({doctorID, appointmentDate}) => ({
        url: `/api/ClinicProfile/GetDoctorSchedulesInCalendar?doctorId=${doctorID}&appointmentDate=${appointmentDate}`,
        method: "GET",
      }),
    }),
    cancelAppointment: builder.mutation({
    query: (formData) => {
      return {
        url: "/api/ClinicProfile/CancelAppointment",
        method: "POST",
        body: formData,
      };
    },
    invalidatesTags: ["Appointments"],
  }),
  }),

});

export const {
  useMakeappointmentMutation,
  useLazyPopulateSelectAppointmentModalQuery,
  useRescheduleAppointmentMutation,
  useGetDoctorsScheduleQuery,
  useLazyGetDoctorsScheduleQuery,
  useCancelAppointmentMutation,
  useNotAttendedAppointmentMutation,
} = MakeAppointmentApiSlice;
